import { useFnrPencilEditInputContext } from "./FnrPencilEditInput";
import { isEditing, isReadOnly } from "./constants";

const useActiveKey = () => {
  const { isEditing: isEditingBool } = useFnrPencilEditInputContext();

  if (isEditingBool) return isEditing;
  return isReadOnly;
};

export { useActiveKey };
